import { OutputTypeStateId } from '../Output';
import { ConditionValidator } from './ConditionValidator';
import { ValueSource } from '../Condition';
import { ValidationError } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/validators/ValidatorError';
import { OutputViewModel } from '../viewModels/OutputViewModel';
export class OutputValidator {
    constructor() {
        this.conditionValidator = new ConditionValidator();
    }
    validate(model) {
        if (!model.stateId) {
            throw new ValidationError('The output state id is required');
        }
        if (model.typeOfStateId === OutputTypeStateId.Variable && model.stateId === ValueSource.Context) {
            throw new ValidationError('The variable value is not defined');
        }
        if (model.typeOfStateId === OutputTypeStateId.Variable && !OutputViewModel.isVariableValue(model.stateId)) {
            throw new ValidationError('Invalid variable reference');
        }
        if (model.conditions) {
            model.conditions.forEach((condition) => this.conditionValidator.validate(condition));
        }
    }
}
